<template>
	
<div class="default-panel">
	<div class="flex-bar">
		<span class="icon-goback" onClick= "history.back();"></span>
		<div class="flex-title">
			<span class="vt-middle">新增地址</span>
		</div>
		<span class="flex-right">
		</span>
	</div>
	<div class="grey-bg-sec">
		<router-link :to="'/login?url='+isFirmOrder">
		<div class="loginTips">
			<ul class="edit-list">
				<li>
					<div class="edit-item">
						<span>如此前已购买过，可直接登录</span>
						<span class="icon-arrow-right"> </span>
					</div>
				</li>
			</ul>
		</div>
		</router-link>
	</div>

	<div class="address-edit-sec">
		<ul class="edit-list">
			<li>
				<div class="edit-item">
					<input type="text" class="input" v-model="name" placeholder="收货人" maxlength="10">
				</div>
			</li>
			<li>
				<div class="edit-item">
					<input type="text" class="input" v-model="phone" maxlength="11" 
					placeholder="收货人手机"
					/>
				</div>
			</li>
			<li>
				<div class="edit-item">
				<input type="text"  class="input" v-model="area" 
					placeholder="收货城市"
					readonly="readonly" 
					@click="popupVisible=true"
					/>
					<span class="icon-arrow-right"></span>
				</div>
			</li>
			<li>
				<div class="edit-item">
					<input type="text"  class="input" v-model="address"  maxlength="100"
					placeholder="详细地址，如街道、楼层、门牌号等"
					/>
				</div>
			</li>
		</ul>

		<ul class="edit-list">
			<li>
				<div class="edit-item">
					<input type="text" class="input" v-model="cusUser"  placeholder="下单人" maxlength="10" >
				</div>
			</li>
			<li>
				<div class="edit-item">
					<input type="text" class="input" v-model="cusPhone" maxlength="11" 
					placeholder="下单人手机"
					/>
				</div>
			</li>
			<li>
				<div class="edit-item no-bor">
					<input type="text"  class="input code-input" v-model="code" 
					placeholder="短信验证码"
					/>
					<button :class="codeBtnClass" type="button" @click="getVaildCode">{{codeText}}</button>
				</div>
			</li>
		</ul>
	</div>

	<button type="button" class="btn-save" @click="noLoginSave">确认</button>


	<mt-popup
 		v-model="popupVisible"
 		class="address-popup"
  		position="bottom">
  		<addressPick
  			:isOrderAddress = hasOwnDelivery
  			v-on:cancel = "togglePopup"
  			v-on:submit = 'setAddressArea'
  		>
  		</addressPick>
	</mt-popup>



</div>

</template>

<script>
	import Vue from 'vue';
	import { CellSwipe } from '@/js/mint-ui';
	import { MessageBox } from '@/js/mint-ui';
	import { Cell } from '@/js/mint-ui';
	import { Popup } from '@/js/mint-ui';
	import { Picker } from '@/js/mint-ui';
	import { Toast } from '@/js/mint-ui';
	Vue.component(Picker.name, Picker);
	Vue.component(Popup.name, Popup);
	Vue.component(Cell.name, Cell);
	Vue.component(CellSwipe.name, CellSwipe);

	import normalBar from '@/components/common/navbar/normalBar'
	import addressPick from '@/components/common/Picker/addressPick'

	import api from '@/api/api.js';
	
	export default {
		data(){
			return {
				name: '',
				phone: '',
				area: '',
				address: '',

				cusUser:'',
				cusPhone:'',
				code: '',

	        	timer: null,
	       		codeBtnClass: 'code',

				popupVisible: false,
				codeText: '获取验证码',
			    disabled: false,

		
			    regionalismId:'',
			    isFirmOrder:'',
			    path:'',
			    hasOwnDelivery: null,//1是有自营配送订单 2是无
			   
			}
		},
		components: {
			normalBar,addressPick
		},
		watch: {
			phone(val){
        		console.log(val)
				this.phone = val.replace(/\D/g,'');
			},
			cusPhone(val){
				this.cusPhone = val.replace(/\D/g,'');
			},
		},
		created(){
			this.hasOwnDelivery = this.$route.query.hasOwnDelivery == 1 ? true: false;
		},
		mounted(){
			this.isFirmOrder =  this.$route.query.isFirmOrder || this.$route.query.isFirmOrder=='true' ? true : false;
			this.isFirmOrder = this.isFirmOrder ? '/firmOrder': undefined;
			
			
		},
		methods: {
			togglePopup(){
				this.popupVisible = false;
			},
			getVaildCode(){
				// this.codeText 
				let self = this;


				if( this.cusPhone =='' || this.cusPhone.length !=11) {
					Toast({
						message: '请输入下单人手机号',
						duration: 1000
					});
					return false;
				}

				if( this.disabled == true ) return false;

				api.get('api/appclient/v2/verifycode/get',{
					mobilePhone: this.cusPhone,
					verifyCodeType: 3

				},function(res){
					let seconds= 60;
					self.disabled = true;
					self.codeBtnClass = 'code codeBtn-disabled'
					self.timer = setInterval(function(){
						seconds --;
						self.codeText = seconds +'s';

						if(seconds <=0){
              clearInterval(self.timer)
              self.codeBtnClass = 'code'
							self.codeText = '获取验证码';
							self.disabled = false;
						}
					},1000)
				})

			},
			noLoginSave(){
				let self = this;
				
					
				if(this.name == ''){
					Toast({
						message: '请填写收货人',
						duration: 1000
					});
					return false;
				} else if(this.phone=='' || this.phone.length != 11){
					Toast({
						message: '请正确填写收货人手机',
						duration: 1000
					});
					return false;
				}else if(this.area==''){
					Toast({
						message: '请选择城市',
						duration: 1000
					});
					return false;
				}else if(this.address==''){
					Toast({
						message: '请填写详情地址',
						duration: 1000
					});
					return false;
				}else if(this.cusUser==''){
					Toast({
						message: '请填写下单人',
						duration: 1000
					});
					return false;
				}else if(this.cusPhone==''){
					Toast({
						message: '请填写下单人手机号',
						duration: 1000
					});
					return false;
				}else if(this.code==''){
					Toast({
						message: '请填写验证码',
						duration: 1000
					});
					return false;
				}
				
				var params = {
					address: self.address,//	详细地址	string	
					mobilePhone: self.cusPhone,//	手机号码	string	
					ownerName: self.cusUser,//	预约人	string	
					recipientMobile: self.phone,//	收货人手机	string	
					recipientName: self.name,//	收货人姓名	string	
					regionalismId: self.regionalismId,//	行政区域ID	number	
					verifyCode: self.code,//
				};

				console.log(params);
				api.post('api/appclient/v2/user/order/login',params,function(res){
					localStorage.setItem('loginCredentials', res.body.data['loginCredentials']);
					localStorage.setItem('userIsLogin', true);
          			localStorage.setItem('userloginTime', new Date());
					self.$router.push({
						name: 'firmOrder',
						query: {
							url: '/shoppingCart'
						}
					})
				})

			},
			
    		setAddressArea(area){
    			this.area = area.pickerArea;
    			this.regionalismId = area.regionalismId;
    			this.popupVisible = false;
    		},
		}

	}
</script>
<style lang="scss">
 	@import '../../assets/css/mixin';
	.address-edit-sec {
		width: 100%;
	}

	.loginTips .edit-list {
		.edit-item {
			padding: pxToRem(50px)  pxToRem(60px) pxToRem(50px) 0;
			border-bottom: none;
		}
	}

.edit-list {
	padding-left: pxToRem(50px);
	background-color: #fff;

	.edit-item {
		border-bottom: 1px solid #666666;
	}

	.edit-item  {
		display: flex;
		justify-content: space-between;
		padding: pxToRem(60px)  pxToRem(60px) pxToRem(30px) 0;
		&.no-bor {
			border: none;
		}

		.input {
			width: 100%;

			&.code-input {
				padding-bottom:  pxToRem(30px);
				width: 65%;
				border-bottom: 1px solid #666666;
			}

		}
		input::-webkit-input-placeholder {
			color: #BDBDBD;
		}
	}
}

.code {
	display: inline-block;
	border: 1px solid #666;
	color: #666;
	background-color: #fff;
	width: pxToRem(180px);
	height: pxToRem(76px);

}

.btn-save {
	margin: pxToRem(100px) auto;
	display: block;
	width: 87%;
	height: pxToRem(100px);
	color: #fff;
	border: none;
	line-height: 1;
	font-size: pxToRem(28px);
	background-color: #D8331D;
}

.address-popup {
	width: 100%;
}
.picker-items {
	width: 100%;
}

.flex-bar {
	padding: 0 pxToRem(30px);
	display: flex;
	justify-content: space-around;
	height: pxToRem(100px);
	line-height: pxToRem(100px);
	border-bottom: 1px solid #eee;
}

.flex-title {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	background-color: rgba(255,255,255,0.90);
}
.edite {
	display: inline-block;
	width: pxToRem(60px);
	color: #666;
}

.codeBtn-disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}
	
</style>


// WEBPACK FOOTER //
// addressNologinAdd.vue?59715ce8